module.exports = __webpack_public_path__ + "static/media/alexdocas22.01f8f8f9.png";